import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Box,
  TableBody,
  Chip,
  Typography,
} from '@mui/material';
import { IAuditTable } from './IAuditTable';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

const ACTION_CONFIG: Record<string, { label: string; color: 'success' | 'info' | 'warning' | 'error' | 'default' }> = {
  SAMPLE_CREATED: { label: 'Sample Created', color: 'success' },
  SAMPLE_UPDATED: { label: 'Sample Updated', color: 'info' },
  RESULT_ADDED: { label: 'Result Added', color: 'warning' },
  RESULT_APPROVED: { label: 'Result Approved', color: 'success' },
  RESULT_REJECTED: { label: 'Result Rejected', color: 'error' },
  ULR_GENERATED: { label: 'ULR Generated', color: 'default' },
  PARAMETER_ASSIGNED: { label: 'Assigned', color: 'info' },
};

export function _AuditTable(props: IAuditTable) {
  const navigate = useNavigate();

  if (!props.data || props.data.length === 0) {
    return (
      <Box p={4} textAlign="center">
        <Typography color="textSecondary">No audit logs found</Typography>
      </Box>
    );
  }

  return (
    <Box>
      <TableContainer>
        <Table sx={{ minWidth: 700, marginTop: '0.6%' }} size="small">
          <TableHead>
            <TableRow>
              <TableCell width={180}>Date / Time</TableCell>
              <TableCell width={160}>Action</TableCell>
              <TableCell width={180}>User</TableCell>
              <TableCell width={200}>Sample ID</TableCell>
              <TableCell>Details</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.data.map((log) => {
              const config = ACTION_CONFIG[log.action] || { label: log.action, color: 'default' as const };
              const sampleIdString = log.sampleId?.sampleId || log.metadata?.sampleIdString || '-';
              const sampleObjectId = typeof log.sampleId === 'object' ? log.sampleId?._id : log.sampleId;

              return (
                <TableRow key={log._id}>
                  <TableCell>{moment(log.createdAt).format('DD/MM/YYYY hh:mm A')}</TableCell>
                  <TableCell>
                    <Chip label={config.label} color={config.color} size="small" variant="outlined" />
                  </TableCell>
                  <TableCell>{log.userId?.name || '-'}</TableCell>
                  <TableCell>
                    <Typography
                      component="span"
                      sx={{
                        cursor: 'pointer',
                        color: 'primary.main',
                        '&:hover': { textDecoration: 'underline' },
                        fontSize: 14,
                      }}
                      onClick={() => {
                        if (sampleObjectId) {
                          navigate(`/laboratory/samples/sampleDetails?id=${sampleObjectId}`);
                        }
                      }}
                    >
                      {sampleIdString}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    {log.changes ? (
                      <Box display="flex" gap={1} flexWrap="wrap">
                        {Object.entries(log.changes).map(([key, value]) => (
                          <Chip
                            key={key}
                            label={`${key}: ${value}`}
                            size="small"
                            variant="outlined"
                            sx={{ fontSize: 12 }}
                          />
                        ))}
                      </Box>
                    ) : (
                      '-'
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export const AuditTable = _AuditTable;
